// Constants for testing and configuration
// Get server URL from environment or use default
const getServerUrl = () => {
  // Check if we're in development or production
  if (process.env.NODE_ENV === 'production') {
    return process.env.UNIFIED_BACKEND_URL || "https://dev-api.phiny.ai";
  }
  // Updated to point to unified-backend (port 8080)
  return process.env.UNIFIED_BACKEND_URL || "http://localhost:8080";
};

// Get voice server URL for LiveKit bot (old interview-backend-webrtc)
const getVoiceServerUrl = () => {
  if (process.env.NODE_ENV === 'production') {
    return process.env.REACT_APP_VOICE_SERVER_URL || process.env.REACT_APP_SERVER_URL || window.location.origin;
  }
  // Old interview-backend-webrtc on port 8004
  return process.env.REACT_APP_VOICE_SERVER_URL || "http://localhost:8004";
};

export const DEFAULT_VALUES = {
  APP_ID: "6877c496855ea191b8d04d92",
  API_KEY: "06440238-7b09-4437-98ce-1120197ad3f6",
  USER_IDENTITY: `test_user_${Date.now()}`,
  SERVER_URL: getServerUrl(),
  VOICE_SERVER_URL: getVoiceServerUrl()
};

export const RUNTIME_DATA_EXAMPLE = {
  components: [{
    hash: "btn123",
    text: "Edit Profile Button",
    componentType: "button",
    isClickable: true,
    children: []
  }, {
    hash: "nav456",
    text: "Profile Navigation",
    componentType: "nav",
    isClickable: true,
    children: []
  }, {
    hash: "text789",
    text: "Profile Information",
    componentType: "p",
    isClickable: false,
    children: []
  }],
  deviceId: "3E8E0B1F-72E9-4F29-83C9-04B1D7B857F5",
  screen: "NAVIGATION_HOME_STACK"
};

export const MESSAGE_TYPES = {
  USER_SPEECH_CHUNK: 'user_speech_chunk',
  AI_SPEECH_CHUNK: 'ai_speech_chunk',
  AI_INTENT: 'ai_intent',
  AI_INTERRUPTED: 'ai_interrupted',
  REQUEST_RUNTIME_DATA: 'request_runtime_data',
  CONNECTION: 'connection',
  KEEPALIVE: 'keepalive',
  INTERVIEWER_JOINED: 'interviewer_joined'
}; 